import React from 'react';
import { Box, Button, makeStyles, useTheme } from '@material-ui/core';
import Image from 'next/image';
import Link from 'next/link';

import Carousel from 'components/ui/Carousel/Carousel';
import { Feedback } from 'domain/types';
import { extraPalette } from 'theme/palette';

const MAX_SLIDES_TO_SHOW = 4;

interface Props {
  feedbacks: Feedback[];
}

const FeedbacksPreview: React.FC<Props> = ({ feedbacks }): JSX.Element => {
  const classes = useStyles();
  const {
    breakpoints: { values: breakpoints }
  } = useTheme();

  const autoplay = feedbacks.length > MAX_SLIDES_TO_SHOW;

  return (
    <>
      <Carousel
      settings={{
        slidesToScroll: 1,
        slidesToShow: 1,
        arrows: true,
        infinite: autoplay,
        autoplay,
        autoplaySpeed: 5000,
        pauseOnHover: true,
        pauseOnFocus: true,
        responsive: [
          {
            breakpoint: breakpoints.sm,
            settings: {
              slidesToShow: 1
            }
          },
          {
            breakpoint: breakpoints.md,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: breakpoints.lg,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 10000,
            settings: {
              slidesToShow: MAX_SLIDES_TO_SHOW
            }
          }
        ],
        className: classes.container
      }}
    >
        {feedbacks.map(({ sys, image }) => (
          <Box key={sys.id} className={classes.imageContainer}>
            <Image
              src={image.url}
              layout="responsive"
              width={image.width}
              height={image.height}
              quality={75}
              alt="Відгук покупця"
            />
          </Box>
        ))}
      </Carousel>

      <Box className={classes.seeAllContainer}>
        <Link href="/feedbacks" passHref>
          <Button variant="outlined" component="a">
            Всі відгуки
          </Button>
        </Link>
      </Box>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  container: {
    ['& .slick-list']: {
      marginLeft: -theme.spacing(1),
      marginRight: -theme.spacing(1)
    },
    ['& .slick-slide']: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      boxSizing: 'border-box'
    },
    [theme.breakpoints.up('sm')]: {
      ['& .slick-list']: {
        marginLeft: -theme.spacing(1.5),
        marginRight: -theme.spacing(1.5)
      },
      ['& .slick-slide']: {
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.5)
      }
    }
  },
  imageContainer: {
    width: '100%',
    borderRadius: 16,
    overflow: 'hidden',
    lineHeight: 0,
    backgroundColor: extraPalette.grey.lightest
  },
  seeAllContainer: {
    textAlign: 'center',
    marginTop: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(4)
    }
  }
}));

export default FeedbacksPreview;
